export type ErrorCode = {
  code?: number | string;
};

// ponytail: string literals — not yet in OpenAPI 409 oneOf.
// Upgrade: generated enums once these codes land in the contract.
export const OFFER_COMPONENT_LOCK_CODES = [
  'COMPONENT_FROZEN',
  'COMPONENT_NOT_DISABLEABLE',
  'COMPONENT_NOT_ENABLABLE',
  'OFFER_ACCEPTED',
] as const;

export type OfferComponentLockCode = (typeof OFFER_COMPONENT_LOCK_CODES)[number];

// The 400 codes of a rejected save of an offer, one list for every place of the save. The codes of the
// term and of the position saves are in the generated enums (`OfferInstanceTermErrorDetailsDtoCodeEnum`,
// `OfferItemErrorDetailsDtoCodeEnum`); a unit test keeps this list covering them. The save of a component
// and the creation of an offer have no typed 400 yet, so their codes are literals.
/** The backend codes (400) of a rejected save of an offer: its term, a component, a position, a new offer. */
export const OFFER_SAVE_ERROR_CODES = [
  'OFFER_COMPONENT_INTERNAL_COST_REQUIRED',
  'OFFER_COMPONENT_NOT_FOUND',
  'OFFER_DEFINITION_INACTIVE',
  'OFFER_ITEM_ASSEMBLY_DESCRIPTION_WITHOUT_ASSEMBLY',
  'OFFER_ITEM_ASSEMBLY_INVALID_ORDER',
  'OFFER_ITEM_ASSEMBLY_NOT_SUPPORTED',
  'OFFER_ITEM_ASSEMBLY_REQUIRES_RESERVATION',
  'OFFER_ITEM_DISASSEMBLY_DESCRIPTION_WITHOUT_DISASSEMBLY',
  'OFFER_ITEM_DISASSEMBLY_INVALID_ORDER',
  'OFFER_ITEM_DISASSEMBLY_NOT_SUPPORTED',
  'OFFER_ITEM_DISASSEMBLY_REQUIRES_RESERVATION',
  'OFFER_ITEM_NAME_REQUIRED',
  'OFFER_ITEM_NOT_FOUND',
  'OFFER_ITEM_PREDEFINED_NOT_DELETABLE',
  'OFFER_ITEM_VALUE_INVALID',
  'OFFER_RESERVATION_CONFIRMED_LOCKED',
  'OFFER_RESERVATION_DICTIONARY_INACTIVE',
  'OFFER_RESERVATION_OUTSIDE_TERM',
  'OFFER_RESERVATION_RANGE_INCOMPLETE',
  'OFFER_RESERVATION_RANGE_INVALID_ORDER',
  'OFFER_TERM_REQUIRED_FOR_RESERVATION',
] as const;

export type OfferSaveErrorCode = (typeof OFFER_SAVE_ERROR_CODES)[number];

export const HTTP_STATUS = {
  ACCEPTED: 202,
  BAD_REQUEST: 400,
  CONFLICT: 409,
  CREATED: 201,
  FORBIDDEN: 403,
  NO_CONTENT: 204,
  NOT_FOUND: 404,
  OK: 200,
  REDIRECT: 302,
  SERVICE_UNAVAILABLE: 503,
  UNAUTHORIZED: 401,
};
